module.exports = __webpack_public_path__ + "static/media/calendario.b1cfa95a.svg";